module.exports = __webpack_public_path__ + "img/icon2.695c723a.svg";